/* GetShareOptions.js */

module.exports.getShareOptions = () => {
  let SHARE_OPTIONS = {};

  if (document.APPLICATION_SHARE_ENABLE_EMBED_CODE !== undefined) {
    SHARE_OPTIONS.EMBED_CODE = document.APPLICATION_SHARE_ENABLE_EMBED_CODE;
  } else {
    SHARE_OPTIONS.EMBED_CODE = (process.env.REACT_APP_SHARE_ENABLE_EMBED_CODE === 'true') ? true : false;
  }

  if (document.APPLICATION_SHARE_ENABLE_EMAIL !== undefined) {
    SHARE_OPTIONS.EMAIL = document.APPLICATION_SHARE_ENABLE_EMAIL;
  } else {
    SHARE_OPTIONS.EMAIL = (process.env.REACT_APP_SHARE_ENABLE_EMAIL === 'true') ? true : false;
  }

  if (document.APPLICATION_SHARE_ENABLE_FACEBOOK !== undefined) {
    SHARE_OPTIONS.FACEBOOK = document.APPLICATION_SHARE_ENABLE_FACEBOOK;
  } else {
    SHARE_OPTIONS.FACEBOOK = (process.env.REACT_APP_SHARE_ENABLE_FACEBOOK === 'true') ? true : false;
  }

  if (document.APPLICATION_SHARE_ENABLE_TWITTER !== undefined) {
    SHARE_OPTIONS.TWITTER = document.APPLICATION_SHARE_ENABLE_TWITTER;
  } else {
    SHARE_OPTIONS.TWITTER = (process.env.REACT_APP_SHARE_ENABLE_TWITTER === 'true') ? true : false;
  }

  if (document.APPLICATION_SHARE_ENABLE_LINKEDIN !== undefined) {
    SHARE_OPTIONS.LINKEDIN = document.APPLICATION_SHARE_ENABLE_LINKEDIN;
  } else {
    SHARE_OPTIONS.LINKEDIN = (process.env.REACT_APP_SHARE_ENABLE_LINKEDIN === 'true') ? true : false;
  }

  return SHARE_OPTIONS;
}
